(() => {
  'use strict';
  const initialized = new WeakSet();
  function init(root = document) {
    root.querySelectorAll('[data-review-hive]').forEach(hive => {
      if (initialized.has(hive)) return;
      initialized.add(hive);
      const viewport = hive.querySelector('.hive-rows');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const loops = [...hive.querySelectorAll('.hive-row')].map(row => {
        const group = row.querySelector('.hive-group'), base = [...group.children];
        if (!base.length) { row.hidden = true; return null; }
        const clone = node => {
          const copy = node.cloneNode(true); copy.setAttribute('aria-hidden', 'true'); copy.inert = true;
          copy.removeAttribute('data-shopify-editor-block');
          copy.querySelectorAll('[data-shopify-editor-block]').forEach(el => el.removeAttribute('data-shopify-editor-block'));
          return copy;
        };
        while (group.children.length < Math.ceil(hive.clientWidth / 170) + 4) base.forEach(cell => group.append(clone(cell)));
        const track = row.querySelector('.hive-track');
        const duplicate = clone(group); track.append(duplicate);
        return { track, group, base, clone, duplicate, count: group.children.length };
      }).filter(Boolean);
      const speed = parseFloat(hive.dataset.speed);
      const pxPerSecond = Number.isFinite(speed) ? speed : 71;
      let phase = 0, last = 0, visible = true, hovering = false, focusing = false, drag = null;
      const cellWidth = () => hive.querySelector('.hive-cell')?.getBoundingClientRect().width || 210;
      const gap = () => parseFloat(getComputedStyle(hive.querySelector('.hive-group')).columnGap) || 0;
      const width = () => cellWidth() + gap();
      const render = () => loops.forEach(loop => {
        const offset = ((phase % loop.count) + loop.count) % loop.count;
        loop.track.style.transform = `translate3d(${-offset * width()}px,0,0)`;
      });
      const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; }); observer.observe(hive);
      const resize = new ResizeObserver(() => {
        loops.forEach(loop => {
          const needed = Math.ceil(hive.clientWidth / width()) + 4;
          if (loop.count >= needed) return;
          while (loop.group.children.length < needed) loop.base.forEach(cell => loop.group.append(loop.clone(cell)));
          loop.duplicate.remove();
          loop.duplicate = loop.clone(loop.group); loop.track.append(loop.duplicate);
          loop.count = loop.group.children.length;
        });
        render();
      }); resize.observe(hive);
      hive.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') hovering = true; });
      hive.addEventListener('pointerleave', () => { hovering = false; });
      hive.addEventListener('focusin', () => { focusing = true; });
      hive.addEventListener('focusout', () => queueMicrotask(() => { focusing = hive.contains(document.activeElement); }));
      viewport.addEventListener('pointerdown', e => {
        if (e.button !== 0) return;
        drag = { id: e.pointerId, x: e.clientX, phase }; viewport.setPointerCapture(e.pointerId);
      });
      viewport.addEventListener('pointermove', e => {
        if (!drag || drag.id !== e.pointerId) return;
        phase = drag.phase + (drag.x - e.clientX) / width(); render();
      });
      ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(type => viewport.addEventListener(type, () => { drag = null; }));
      viewport.addEventListener('keydown', e => {
        if (!['ArrowLeft', 'ArrowRight'].includes(e.key)) return;
        e.preventDefault(); phase += e.key === 'ArrowRight' ? 1 : -1; render();
      });
      function tick(now) {
        if (!hive.isConnected) { observer.disconnect(); resize.disconnect(); return; }
        const elapsed = Math.min(now - last || 0, 50); last = now;
        if (visible && !document.hidden && !reduced.matches && !hovering && !focusing && !drag) { phase += elapsed * pxPerSecond / 1000 / width(); render(); }
        requestAnimationFrame(tick);
      }
      render(); requestAnimationFrame(tick);
    });
  }
  init(); document.addEventListener('shopify:section:load', e => init(e.target));
})();
